document.addEventListener('turbo:load', function(e) {

  /* --------------------------------------------------
                Get Location
  -------------------------------------------------- */
  pgJobsFormGetLocationInit = function(){
    let locationInput = document.getElementById('job_location');
    let locationInputLat = document.getElementById('job_location_lat');
    let locationInputLng = document.getElementById('job_location_lng');

    if (locationInput) {
      // Load Google Maps API if not already loaded
      if (typeof google === 'undefined') {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${locationInput.dataset.apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => initializeAutocomplete();
        document.head.appendChild(script);
      } else {
        initializeAutocomplete();
      }

      function initializeAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(locationInput, {
          types: ['address'],
          componentRestrictions: { country: ['us'] } // Restrict to United States
        });

        // When a place is selected from the autocomplete
        autocomplete.addListener('place_changed', function() {
          const place = autocomplete.getPlace();

          if (!place.geometry) {
            alert('No details available for input: ' + place.name);
            return;
          }

          // Update the hidden lat/lng fields
          locationInputLat.value = place.geometry.location.lat();
          locationInputLng.value = place.geometry.location.lng();
        });

        // Prevent form submission when pressing enter on the autocomplete field
        locationInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        });
      }
    }
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pgJobsFormGetLocationInit();
});
